// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-day-button {
  background-color: #2954a5 !important;
  color: white !important;
  width: 60% !important;
  border-radius: 7px !important;
  margin-top: 10px !important;
  margin-bottom: 12px !important;
}

.start-day-button-disable {
  background-color: rgb(181, 208, 250) !important;
  color: white !important;
  width: 60% !important;
  border-radius: 7px !important;
  margin-top: 10px !important;
  margin-bottom: 12px !important;
  cursor: not-allowed !important;
}

.soft-select-wrapper {
  width: 80% !important;
}

@media (max-width: 768px) {
  .soft-select-wrapper {
    width: 100% !important;
  }
}
.start-session-button {
  width: 100%;
}

.no-day-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  gap: 1rem;
}

.no-day-text {
  color: #6c757d;
  font-size: 18px;
  text-align: center;
}

.session-page-inner-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.startText {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--surface-black);
}

.no-day-text-v2 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--surface-g5);
  margin-bottom: 2px;
}

.newSessionRightContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.newSessionRightInnerContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.startPgaeRightContainer {
  width: 100%;
  padding: 0px 64px;
}

/* ── Day Closing Success Screen ── */

.day-close-success-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px;
  width: 100%;
  max-width: 480px;
  animation: dcsFadeIn 0.3s ease both;
}

@keyframes dcsFadeIn {
  from {
    opacity: 0;
    transform: scale(0.97) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.day-close-success-icon-ring {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #d1fae5; /* emerald-100 equivalent */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.day-close-success-icon {
  width: 48px;
  height: 48px;
  color: #059669; /* emerald-600 equivalent */
  stroke: #059669;
}

.day-close-success-title {
  font-size: 1.875rem; /* was 1.75rem */
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px 0;
}

.day-close-success-subtitle {
  font-size: 0.9375rem;
  color: #64748b;
  max-width: 448px; /* was 380px */
  margin: 0 0 40px 0; /* was 32px */
  line-height: 1.55;
}

.day-close-success-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px; /* was 12px */
  width: 100%;
  max-width: 448px; /* was 400px */
  margin-bottom: 0;
}

.day-close-logout-section {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 28px;
  padding-top: 28px;
  border-top: 1px solid #f1f5f9;
  width: 100%;
  max-width: 400px;
}

.day-close-logout-section > p {
  font-weight: 700;
  color: #ff3333;
}

.day-close-success-eod {
  margin-top: 32px; /* was 28px */
  padding-top: 32px; /* was 28px */
  border-top: 1px solid #f1f5f9;
  width: 100%;
  max-width: 448px; /* was 400px */
}

.day-close-success-eod-label {
  font-size: 0.875rem; /* was 0.75rem */
  font-weight: 500;
  color: #64748b; /* was #94a3b8 */
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 16px 0;
}

/* ── DayClosing native buttons ── */

.dcs-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 56px;
  padding: 0 32px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 14px; /* was 8px, Tailwind rounded-md */
  border: none;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease,
    opacity 0.15s ease;
  white-space: nowrap;
}

.dcs-btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Outline / ghost — Start New Session */
.dcs-btn-outline {
  background-color: transparent;
  color: #334155;
  border: 1px solid #cbd5e1;
}

.dcs-btn-outline:hover {
  background-color: #f8fafc;
}

.dcs-btn-outline:active {
  background-color: #f1f5f9;
}

/* Dark — Close Day Sales */
.dcs-btn-dark {
  background-color: #0f172a;
  color: #ffffff;
  border: 1px solid #1e293b;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1); /* shadow-xl */
  margin-bottom: 16px; /* was 12px */
}

.dcs-btn-dark:hover {
  background-color: #1e293b;
}

.dcs-btn-dark:active {
  box-shadow: none;
  background-color: #334155;
}

/* Logout — ghost red */
.dcs-btn-logout {
  background-color: transparent;
  color: #e11d48;
  border: 1px solid transparent;
}

.dcs-btn-logout:hover {
  background-color: #fff1f2;
  color: #be123c;
}

.dcs-btn-logout:active {
  background-color: #ffe4e6;
}

/* Icons inside buttons */
.dcs-btn-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.dcs-btn-icon-right {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Loading spinner for dark button */
.dcs-btn-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: dcsSpin 0.7s linear infinite;
}

/* Loading spinner for light/outline/ghost buttons — tracks the button's own text color */
.dcs-btn-spinner-light {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(15, 23, 42, 0.15);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: dcsSpin 0.7s linear infinite;
}

@keyframes dcsSpin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/startDay.js/index.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,2BAA2B;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,2BAA2B;EAC3C,eAAe;AACjB;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB,EAAE,cAAc;EAChC,kBAAkB,EAAE,aAAa;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS,EAAE,aAAa;EACxB,WAAW;EACX,gBAAgB,EAAE,cAAc;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,aAAa;EAC/B,iBAAiB,EAAE,aAAa;EAChC,6BAA6B;EAC7B,WAAW;EACX,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,gBAAgB;EAChB,cAAc,EAAE,gBAAgB;EAChC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,oCAAoC;;AAEpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,iCAAiC;EACtD,YAAY;EACZ,eAAe;EACf;;;sBAGoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB;;sCAEoC,EAAE,cAAc;EACpD,mBAAmB,EAAE,aAAa;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,yFAAyF;AACzF;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".start-day-button {\n  background-color: #2954a5 !important;\n  color: white !important;\n  width: 60% !important;\n  border-radius: 7px !important;\n  margin-top: 10px !important;\n  margin-bottom: 12px !important;\n}\n\n.start-day-button-disable {\n  background-color: rgb(181, 208, 250) !important;\n  color: white !important;\n  width: 60% !important;\n  border-radius: 7px !important;\n  margin-top: 10px !important;\n  margin-bottom: 12px !important;\n  cursor: not-allowed !important;\n}\n\n.soft-select-wrapper {\n  width: 80% !important;\n}\n\n@media (max-width: 768px) {\n  .soft-select-wrapper {\n    width: 100% !important;\n  }\n}\n.start-session-button {\n  width: 100%;\n}\n\n.no-day-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.no-day-text {\n  color: #6c757d;\n  font-size: 18px;\n  text-align: center;\n}\n\n.session-page-inner-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n}\n\n.startText {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--surface-black);\n}\n\n.no-day-text-v2 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--surface-g5);\n  margin-bottom: 2px;\n}\n\n.newSessionRightContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n}\n\n.newSessionRightInnerContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.startPgaeRightContainer {\n  width: 100%;\n  padding: 0px 64px;\n}\n\n/* ── Day Closing Success Screen ── */\n\n.day-close-success-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 24px;\n  width: 100%;\n  max-width: 480px;\n  animation: dcsFadeIn 0.3s ease both;\n}\n\n@keyframes dcsFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.97) translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.day-close-success-icon-ring {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background-color: #d1fae5; /* emerald-100 equivalent */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.day-close-success-icon {\n  width: 48px;\n  height: 48px;\n  color: #059669; /* emerald-600 equivalent */\n  stroke: #059669;\n}\n\n.day-close-success-title {\n  font-size: 1.875rem; /* was 1.75rem */\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 8px 0;\n}\n\n.day-close-success-subtitle {\n  font-size: 0.9375rem;\n  color: #64748b;\n  max-width: 448px; /* was 380px */\n  margin: 0 0 40px 0; /* was 32px */\n  line-height: 1.55;\n}\n\n.day-close-success-actions {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px; /* was 12px */\n  width: 100%;\n  max-width: 448px; /* was 400px */\n  margin-bottom: 0;\n}\n\n.day-close-logout-section {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  margin-top: 28px;\n  padding-top: 28px;\n  border-top: 1px solid #f1f5f9;\n  width: 100%;\n  max-width: 400px;\n}\n\n.day-close-logout-section > p {\n  font-weight: 700;\n  color: #ff3333;\n}\n\n.day-close-success-eod {\n  margin-top: 32px; /* was 28px */\n  padding-top: 32px; /* was 28px */\n  border-top: 1px solid #f1f5f9;\n  width: 100%;\n  max-width: 448px; /* was 400px */\n}\n\n.day-close-success-eod-label {\n  font-size: 0.875rem; /* was 0.75rem */\n  font-weight: 500;\n  color: #64748b; /* was #94a3b8 */\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin: 0 0 16px 0;\n}\n\n/* ── DayClosing native buttons ── */\n\n.dcs-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 56px;\n  padding: 0 32px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 14px; /* was 8px, Tailwind rounded-md */\n  border: none;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    box-shadow 0.15s ease,\n    opacity 0.15s ease;\n  white-space: nowrap;\n}\n\n.dcs-btn:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* Outline / ghost — Start New Session */\n.dcs-btn-outline {\n  background-color: transparent;\n  color: #334155;\n  border: 1px solid #cbd5e1;\n}\n\n.dcs-btn-outline:hover {\n  background-color: #f8fafc;\n}\n\n.dcs-btn-outline:active {\n  background-color: #f1f5f9;\n}\n\n/* Dark — Close Day Sales */\n.dcs-btn-dark {\n  background-color: #0f172a;\n  color: #ffffff;\n  border: 1px solid #1e293b;\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 8px 10px -6px rgba(0, 0, 0, 0.1); /* shadow-xl */\n  margin-bottom: 16px; /* was 12px */\n}\n\n.dcs-btn-dark:hover {\n  background-color: #1e293b;\n}\n\n.dcs-btn-dark:active {\n  box-shadow: none;\n  background-color: #334155;\n}\n\n/* Logout — ghost red */\n.dcs-btn-logout {\n  background-color: transparent;\n  color: #e11d48;\n  border: 1px solid transparent;\n}\n\n.dcs-btn-logout:hover {\n  background-color: #fff1f2;\n  color: #be123c;\n}\n\n.dcs-btn-logout:active {\n  background-color: #ffe4e6;\n}\n\n/* Icons inside buttons */\n.dcs-btn-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.dcs-btn-icon-right {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Loading spinner for dark button */\n.dcs-btn-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: dcsSpin 0.7s linear infinite;\n}\n\n/* Loading spinner for light/outline/ghost buttons — tracks the button's own text color */\n.dcs-btn-spinner-light {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(15, 23, 42, 0.15);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: dcsSpin 0.7s linear infinite;\n}\n\n@keyframes dcsSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
